import { TOAST } from '../../ClaimWebsite/types';
import { ToastAction, ToastType } from '../../../config/interface';

export default function setToast(toast:ToastType): ToastAction {
  return {
    type: TOAST,
    toast,
  };
}
